// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mdi-qrcode-scan {\n  color: #4a6ca5;\n}\n.edcard-form .avatar-wrapper {\n  background: white;\n  border-radius: 100px !important;\n}\n.edcard-form .avatar-wrapper i {\n  /*font-size: 2rem;*/\n}", ""]);
// Exports
module.exports = exports;
